import { Fragment, ReactNode } from 'react';
import { useImageStoreActions } from '../../stores/imageStore';
import { Coordinate, HighlighterVariantType } from '../../types';
import './imageHighlighter.styles.css';

type HighlighterPropsType = {
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    top: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    height: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    left: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    width: number;
    variant: HighlighterVariantType;
};

function Highlighter({ top, height, left, width, variant }: HighlighterPropsType) {
    const styles = {
        top: `${top * 100}%`,
        height: `${height * 100}%`,
        left: `${left * 100}%`,
        width: `${width * 100}%`,
    };

    return <div className={`highlighter highlighter--${variant}`} style={styles}></div>;
}

type HighlighterWrapperProps = {
    coordinates: Coordinate[];
    children: ReactNode;
};

export function ImageHighlighterWrapper({ children, coordinates }: HighlighterWrapperProps) {
    const actions = useImageStoreActions();
    return (
        <div
            className="image-highlighter__wrapper"
            onPointerEnter={() => actions.setCoordinates(coordinates)}
            onPointerLeave={actions.clearCoordinates}
        >
            {children}
        </div>
    );
}

type ImageHighlighterPropsType = {
    children: ReactNode;
    coordinates: Coordinate[];
};

function ImageHighlighter({ coordinates, children }: ImageHighlighterPropsType) {
    return (
        <div className="image-highlighter">
            {children}
            {coordinates.map((coords, index) => {
                return (
                    <Fragment key={index}>
                        <Highlighter
                            top={coords.top}
                            height={coords.height}
                            left={coords.left}
                            width={coords.width}
                            variant={coords.variant}
                        />
                    </Fragment>
                );
            })}
        </div>
    );
}

export default ImageHighlighter;
